"use strict";

var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Image = _styledComponents.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  transition: ", ";\n  transform: ", ";\n  visibility: ", ";\n\n  &:hover {\n    cursor: ", ";\n  }\n\n  backface-visibility: hidden;\n"])), _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.top, _styledSystem.right, _styledSystem.bottom, _styledSystem.left, _styledSystem.position, _styledSystem.display, _styledSystem.zIndex, _styledSystem.maxWidth, _styledSystem.opacity, _styledSystem.maxHeight, _styledSystem.borderRadius, function (props) {
  return props.transition || 'all 0s 0s ease';
}, function (props) {
  return props.transform || 'none';
}, function (props) {
  return props.visibility || 'visible';
}, function (props) {
  return props.hover ? 'pointer' : 'auto';
});

exports.Image = Image;